import axios from "axios";
import { cacheAdapterEnhancer } from 'axios-extensions';

const cacheConfig = {
    enabledByDefault: false,
    cacheFlag: 'useCache'
}

const customAxios = axios.create({
    headers: {
        'Cache-Control': 'no-cache'
    },
    adapter: cacheAdapterEnhancer(axios.defaults.adapter, cacheConfig),
});

customAxios.interceptors.response.use((response) => {
    return response;
}, (error) => {
    if (error.response) {
        if (error.response.status === 401) {
            window.location.href = "/accounts/login/";
        }
        if (error.response.data) {
            return Promise.reject(error.response);
        }
    }
    return Promise.reject(error.response);
});

customAxios.defaults.headers.common["X-CSRFToken"] = document.head.querySelector("[name~=csrftoken][content]").content;

export default customAxios;
